module.exports = __webpack_public_path__ + "media/images/emblems/Sergey-f28c2bae5b03365c0c1e28cdd816dbda.png";